"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.FooterNavItem = exports.FooterTitle = exports.FooterContainer = exports.FooterHtmlContainer = exports.FooterContactSection = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _mediaQueries = _interopRequireDefault(require("../../../styles/mediaQueries"));

var _NavigationList = require("../../Navigation/NavigationList/NavigationList.style");

var _Layout = require("../../Layout");

var _Typography = require("../../Typography");

var FooterContactSection = (0, _styled.default)('div')(function (_ref) {
  var _ref$theme = _ref.theme,
      space = _ref$theme.space,
      colors = _ref$theme.colors,
      footer = _ref$theme.footer;
  return _defineProperty({
    height: 'auto',
    padding: "".concat(space.large, " 0"),
    color: colors[footer.footerContactSectionColor]
  }, _mediaQueries.default.medium, {
    padding: "".concat(space.small, " 0")
  });
});
exports.FooterContactSection = FooterContactSection;
var FooterHtmlContainer = (0, _styled.default)(_Layout.Container)(function (_ref3) {
  var _ref4;

  var _ref3$theme = _ref3.theme,
      colors = _ref3$theme.colors,
      space = _ref3$theme.space,
      footer = _ref3$theme.footer;
  return _ref4 = {}, _defineProperty(_ref4, _mediaQueries.default.medium, {
    padding: "".concat(space.small, " 0"),
    color: colors[footer.footerHtmlContainerColor]
  }), _defineProperty(_ref4, "p", _defineProperty({
    marginBottom: space.small,
    fontSize: "".concat(footer.FooterHtmlContainerFontSizeMobile, " !important")
  }, _mediaQueries.default.medium, {
    fontSize: "".concat(footer.FooterHtmlContainerFontSizeDesktop, " !important")
  })), _ref4;
});
exports.FooterHtmlContainer = FooterHtmlContainer;
var FooterContainer = (0, _styled.default)(_NavigationList.NavItemContainer)(function (_ref5) {
  var _ref5$theme = _ref5.theme,
      colors = _ref5$theme.colors,
      footer = _ref5$theme.footer;
  return _defineProperty({
    color: colors[footer.footerContainerColorMobile],
    fontWeight: 'bold',
    cursor: 'initial',
    paddingBottom: '0'
  }, _mediaQueries.default.medium, {
    color: colors[footer.footerContainerColorDesktop]
  });
});
exports.FooterContainer = FooterContainer;
var FooterTitle = (0, _styled.default)(_Typography.Body)(function (_ref7) {
  var _ref7$theme = _ref7.theme,
      colors = _ref7$theme.colors,
      space = _ref7$theme.space;
  return {
    margin: 0,
    fontWeight: 'bold',
    borderBottom: "1px solid ".concat(colors.greymid),
    paddingBottom: space.medium,
    width: '100%'
  };
});
exports.FooterTitle = FooterTitle;
var FooterNavItem = (0, _styled.default)(_NavigationList.NavItem)(function (_ref8) {
  var _ref8$theme = _ref8.theme,
      colors = _ref8$theme.colors,
      footer = _ref8$theme.footer;
  return {
    background: colors[footer.footerNavItemBg],
    a: {
      color: colors[footer.footerNavItemColor],
      '&:hover': {
        textDecoration: 'underline',
        color: colors[footer.footerNavItemColorHover]
      }
    }
  };
});
exports.FooterNavItem = FooterNavItem;